<template lang="html">
    <div id="">
        <navbar v-if="!$route.meta.hideNavbar"></navbar>
        <router-view></router-view>
        <musterfooter v-if="!$route.meta.hideFooter"></musterfooter>
    </div>
</template>

<script>
    import NavBar from "@/components/navbar-new.vue";
    import Footer from "@/components/home/home-footer.vue";
    export default {
        name: "app",
        components: {
            navbar: NavBar,
            musterfooter : Footer,
        },
    };
</script>
